<template>
    <div :id="gantt_ref"></div>

</template>

<script>
    import 'dhtmlx-gantt'
    import moment from 'moment'
    // import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js";
    import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_quick_info.js";

    let timezone = new Date()
    timezone = timezone.getTimezoneOffset() / 60

    gantt.templates.timeline_cell_class = function (task, date) {
        const css = [];
        if (task) {
            const isValid = moment(task.end_date).isAfter(moment(date)) && moment(task.start_date).isBefore(moment(date).add(1, 'hours'))
            if (task.text && isValid) {
                css.push(task.text.replace(/\s/g, ''))
            }
        }
        return css.join(" ");
    };

    export default {
        name: 'gantt',
        props: {
            gantt_ref: String,
            predictedHours: Array,
            date: Date,
            code: String,
            edit: Boolean,
            editted: Number,
            hourlyType: String,
            refresh: Number,
            clear: Boolean,
            tasks: {
                type: Object,
                default() {
                    return {data: [], links: [], hours: []}
                }
            },
            taskToDelete: Number,
            noPredictions: {
                type: Boolean,
                default() {
                    return false
                }
            }

        },
        data() {
            return {
                showDetails: false,
                quickInfoShowing: true,
                quickInfoId: null,
                tasksShowing: []
            }
        },
        computed: {
            countTasks() {
                let tasks = this.tasksShowing
                let predHours
                if (this.code == 'all') {
                    predHours = this.predictedHours
                } else if(this.code == 'battery_light_service') {
                    predHours = this.predictedHours.filter(p => {
                        if (['Battery', 'Light Service', 'battery_light_service'].includes(p.code)) {return p}
                    })
                } else if(this.code == 'tow_light_service') {
                    predHours = this.predictedHours.filter(p => {
                        if (['Tow', 'Light Service', 'tow_light_service'].includes(p.code)) {return p}
                    })
                } else {
                    predHours = this.predictedHours.filter(p => {
                        if (p.code === this.code) return p
                    })
                }




                let newHours = []
                let date = []
                let currIndex = 0

                if (['4h', '1d'].includes(this.hourlyType)) {
                    let hour_step = parseInt(this.hourlyType.split('')[0])
                    let multiply = hour_step === 4 ? hour_step : 24
                    let hours = []
                    predHours.forEach((p, index) => {
                        let driver_counted = []
                        hours.push({
                            time: moment(p.sc_dt).format('MM/DD/YYYY HH:00'),
                            goal: p.total_drivers > -1 ? p.total_drivers : 0,
                            actual: 0
                        })
                        let hour_idx = index * multiply
                        for (let i = 0; i < multiply; i++) {
                            let hour_start = moment(p.sc_dt).add(i, 'hours').format('MM/DD/YYYY HH:00')
                            if (tasks.length > 0) {
                                for (let j = 0; j < tasks.length; j++) {
                                    if (moment(tasks[j].start_date).format('MM/DD/YYYY HH:00') <= hour_start
                                        && moment(tasks[j].end_date).format('MM/DD/YYYY HH:00') > hour_start
                                        && !driver_counted.includes(tasks[j].id)) {
                                        hours[hour_idx].actual++
                                        driver_counted.push(tasks[j].id)
                                    }
                                }
                            }
                            if (hour_start != hours[hour_idx].time){
                                hours.push({
                                    time: hour_start,
                                    goal: p.total_drivers > -1 ? p.total_drivers : 0,
                                    actual: 0
                                })
                            }

                        }
                    })
                    // hours = hours
                    return hours
                }




                predHours.forEach(p => {
                    let total_drivers = p.total_drivers > -1 ? p.total_drivers : 0
                    if (!date.includes(p.sc_dt)) {
                        newHours.push({sc_dt: p.sc_dt, volume_pred: parseFloat(p.volume_pred), goal: total_drivers})
                        date.push(p.sc_dt)
                    } else {
                        currIndex = date.indexOf(p.sc_dt)
                        newHours[currIndex].volume_pred += parseFloat(p.volume_pred)
                        newHours[currIndex].goal += parseFloat(total_drivers)
                    }
                })
                let hours = newHours.map(w => {
                    let actual = 0;
                    for (let i in tasks) {
                        if (moment(tasks[i].start_date).format('MM/DD/YYYY HH:00') <= w.sc_dt
                            && moment(tasks[i].end_date).format('MM/DD/YYYY HH:00') > w.sc_dt) {
                            actual++
                        }
                    }
                    // let actualGoal;
                    //
                    // if (w.volume_pred == 0) {
                    //     actualGoal = 0
                    // } else {
                    //     actualGoal = Math.round(w.volume_pred / w.goal)
                    //     if (actualGoal == 0) actualGoal = 1
                    // }
                    //
                    // if (actualGoal < 0) {
                    //     actualGoal = 0
                    // }
                    return {time: w.sc_dt, goal: w.goal, actual: actual}
                })

                return hours
            },
            adjustedHours() {
                let predHours
                if (this.code == 'all') {
                    predHours = this.predictedHours
                } else if(this.code == 'battery_light_service') {
                    predHours = this.predictedHours.filter(p => {
                        if (['Battery', 'Light Service', 'battery_light_service'].includes(p.code)) {return p}
                    })
                } else if(this.code == 'tow_light_service') {
                    predHours = this.predictedHours.filter(p => {
                        if (['Tow', 'Light Service', 'tow_light_service'].includes(p.code)) {return p}
                    })
                } else {
                    predHours = this.predictedHours.filter(p => {
                        if (p.code === this.code) return p
                    })
                }
                let hour_step = parseInt(this.hourlyType.split('')[0])
                let multiply = hour_step === 4 ? hour_step : 24
                let hours = []
                predHours.forEach((p, index) => {
                    hours.push(moment(p.sc_dt).format('MM/DD/YYYY HH:00'))
                    let hour_idx = index * multiply
                    for (let i = 0; i < multiply; i++) {
                        let hour_start = moment(p.sc_dt).add(i, 'hours').format('MM/DD/YYYY HH:00')
                        if (!hours.includes(hour_start)){
                            hours.push(hour_start)
                        }
                    }
                })
                // hours = hours
                return hours
            }

        },

        methods: {
            $_initGanttEvents: function () {
                let _t = this
                if (gantt.$_eventsInitialized)
                    return;
                gantt.attachEvent('onTaskSelected', (id) => {
                    let task = gantt.getTask(id)
                    this.$emit('task-selected', task)

                })

                gantt.attachEvent('onAfterTaskAdd', (id, task) => {
                    this.$emit('task-updated', id, 'inserted', task)
                    task.progress = task.progress || 0
                    if (gantt.getSelectedId() == id) {
                        this.$emit('task-selected', task)
                    }

                })

                gantt.attachEvent('onAfterTaskUpdate', (id, task) => {
                    this.$emit('task-updated', id, 'updated', task)
                })

                gantt.attachEvent('onAfterTaskDelete', (id) => {
                    this.$emit('task-updated', id, 'deleted', {})
                    if (!gantt.getSelectedId()) {
                        _t.$emit('task-selected', null)
                    }
                })

                gantt.attachEvent('onBeforeTaskDisplay', (id, task) => {
                    let code = (this.code == 'Other') ? 'Light Service' : this.code
                    if (code == 'all') {
                        return true
                    } else if (code == 'tow_light_service') {
                        if (['Tow', 'Light Service', 'tow_light_service'].includes(task.serviceType)) return true
                    } else if (code == 'battery_light_service') {
                        if (['Battery', 'Light Service', 'battery_light_service'].includes(task.serviceType)) return true
                    } else {
                        if (code == task.serviceType) {
                            return true
                        } else {
                            return false
                        }
                    }
                })

                gantt.attachEvent('onTaskDblClick', (id, e) => {
                    this.$emit('droppedInfo', id)

                })

                gantt.attachEvent('onAfterLinkAdd', (id, link) => {
                    this.$emit('link-updated', id, 'inserted', link)
                })

                gantt.attachEvent('onAfterLinkUpdate', (id, link) => {
                    this.$emit('link-updated', id, 'updated', link)
                })

                gantt.attachEvent('onAfterLinkDelete', (id, link) => {
                    this.$emit('link-updated', id, 'deleted')
                })

                gantt.attachEvent('onLightbox', (id) => {
                    gantt.deleteTask(id)
                    let lb = gantt.getLightboxType()
                    return true
                })
                gantt.$_eventsInitialized = true;
            },
            $_getDurationTxt: function (duration) {
                const hours = Math.floor(duration / 4);
                const availableHours = hours > 0 ? (hours + (hours === 1 ? " hour " : " hours ")) : "";
                const minutes = (duration / 4 - Math.floor(duration / 4)) * 60;
                const availableMinutes = minutes > 0 ? (minutes + (minutes === 1 ? " minute" : " minutes")) : "";
                return availableHours + availableMinutes;
            },
            initialSetup() {
                this.$_initGanttEvents();
                let hourStepLookup = {
                    '1h': 1,
                    '4h': 4,
                    '1d': 24
                }
                let hourStep = hourStepLookup[this.hourlyType]
                const d = new Date(this.date);
                const _t = this;
                let listValue = _t.predictedHours
                let timeDeltaLookup = {
                    '1h': 31,
                    '4h': 31,
                    '1d': 31
                }

                let dayFormat = "%D, %d, %F, %Y"

                if (this.hourlyType == '1d') {
                    dayFormat = "%m-%d"
                }

                gantt.config.start_date = moment.utc(d).subtract(d.getHours(), 'hours').subtract(d.getMinutes(), 'minutes');
                gantt.config.end_date = moment.utc(d).subtract(d.getHours(), 'hours').add(timeDeltaLookup[this.hourlyType], 'hours')
                gantt.config.scales = [
                    {
                        unit: "day", step: 1, format: dayFormat, css: function (date) {
                            return 'black_text'
                        }
                    },
                    {
                        unit: "hour", step: hourStep, format: function (date) {
                            let hour_format
                            if (hourStep == 1)
                                hour_format = moment(date).format('h:mmA')
                            if (hourStep == 4)
                                hour_format = moment(date).format('h:mmA') + '-' + moment(date).add(3, 'hours').format('h:59A')
                            if (hourStep == 24)
                                hour_format = moment(date).format('dddd')

                            return hour_format
                        }, css: function (date) {
                            if (listValue) {
                                let taskGoal = listValue.map(w => {
                                    return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                })
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index
                                })
                                // checks to see if the cell date is in the task goal list\
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                    // this will compare the goal of the task vs the actual (how many people are working said hour)
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity || goal == undefined) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (goal === actual) {
                                        // if gaol = actual then its green (goal is met)
                                        return 'at_goal_date'
                                    } else if (goal - 1 == actual) {
                                        // if its above, then its warning (yellow/over coverage)
                                        return 'warning_date'
                                    } else if (goal < actual) {
                                        return 'over_goal_date'
                                    } else {
                                        // if its below goal the it is danger (red/low coverage)
                                        return 'danger_date'
                                    }
                                }
                            }
                            return 'black_text'
                        },

                    },

                    // {unit: 'hour', steps: 1, format: function(date) { return moment(date).format('hA')}}

                ];
                if (!this.noPredictions) {
                    gantt.config.scales.push({
                        unit: 'hour', step: hourStep, format: function(date) {
                            if(_t.predictedHours.length === 0) {
                                return ''
                            } else {
                                let taskGoal = listValue.map(w => {
                                    return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                })
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index;
                                })
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (!isNaN(actual) && !isNaN(goal))
                                        return actual + ' / ' + goal
                                    else
                                        return ''
                                } else {
                                    return ''
                                }
                            }
                        }, css: function (date) {
                                if (listValue) {
                                    let taskGoal = listValue.map(w => {
                                        return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                    })
                                    taskGoal = taskGoal.filter((value, index, self) => {
                                        return self.indexOf(value) === index
                                    })
                                    // checks to see if the cell date is in the task goal list\
                                    if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                        // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                        // this will compare the goal of the task vs the actual (how many people are working said hour)
                                        let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                        let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                        if (goal == null || goal == Infinity) {
                                            goal = 0
                                        }
                                        let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                        if (goal === actual) {
                                            // if gaol = actual then its green (goal is met)
                                            return 'at_goal_date'
                                        } else if (goal - 1 == actual) {
                                            // if its above, then its warning (yellow/over coverage)
                                            return 'warning_date'
                                        } else if (goal < actual) {
                                            return 'over_goal_date'
                                        } else {
                                            // if its below goal the it is danger (red/low coverage)
                                            return 'danger_date'
                                        }
                                    }
                                }
                                return 'black_text'
                            }
                    })
                }
                if (['4h', '1d'].includes(this.hourlyType) && !this.noPredictions) {
                    let taskGoal = this.adjustedHours

                    gantt.config.scales.push({
                        unit: "hour", step: 1, format: function (date) {
                            return moment(date).format('h:mmA')
                        }, css: function (date) {
                            if (listValue) {
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index
                                })
                                // checks to see if the cell date is in the task goal list\
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                    // this will compare the goal of the task vs the actual (how many people are working said hour)
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity || goal == undefined) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (goal === actual) {
                                        // if gaol = actual then its green (goal is met)
                                        return 'at_goal_date'
                                    } else if (goal - 1 == actual) {
                                        // if its above, then its warning (yellow/over coverage)
                                        return 'warning_date'
                                    } else if (goal < actual) {
                                        return 'over_goal_date'
                                    } else {
                                        // if its below goal the it is danger (red/low coverage)
                                        return 'danger_date'
                                    }
                                }
                            }
                            return 'black_text'
                        }
                    },)
                }
                if (this.hourlyType == '1d') {
                    gantt.config.scales.splice(1, 1)
                }
                gantt.config.columns = [
                    {width: 0}
                ];

                gantt.templates.quick_info_content = function (start, end, task) {
                    let tooltip_text = "<b>Driver Name:</b> " + task.text +
                        "<br/><b>Start Time</b> " + moment.utc(task.start_date).subtract(timezone, 'hours').format('MM/DD/YYYY h:mmA') +
                        "<br /><b>End Time</b> " + moment.utc(task.end_date).subtract(timezone, 'hours').format('MM/DD/YYYY h:mmA') +
                        "<br/><b>Duration:</b> " + task.duration / 4 +
                        "<br/><b>Availability:</b> " + moment.utc().set({hour: task.available_start.hour, minute: task.available_start.minutes, second: 0, millisecond: 0}).format('h:mmA') +
                        " to " + moment.utc().set({hour: task.available_end.hour, minute: task.available_end.minutes, second: 0, millisecond: 0}).format('h:mmA') +
                        "<br/><b>Service Type:</b> " + (task.all_tcd.length > 0 ?  task.all_tcd.join(', ') : task.serviceType)
                    ;
                    if (task.color == '#000') {
                        tooltip_text += "<br/><b>NOTE:</b> This driver is scheduled outside of their availability."
                    }
                    return tooltip_text
                };
                gantt.config.duration_unit = "minute";
                gantt.config.duration_step = 15;
                gantt.config.min_column_width = 70;
                gantt.config.scale_height = 20 * 3;
                gantt.config.autosize = false
                gantt.config.initial_scroll = false
                gantt.config.drag_move = this.edit
                // gantt.config.details_on_dbclick = this.edit
                // gantt.config.quick_info_detached = false
                gantt.templates.quick_info_title = function(start, end, task) {
                    return '';
                }
                gantt.templates.quick_info_class = function(start, end, task) {
                    return 'quick-info'
                }
                // gantt.templates.quick_info_class =

                // gantt.config.show_quick_info = this.edit

                gantt.templates.rightside_text = function (start, end, task) {
                    return ''
                }
                gantt.templates.scale_cell_class = function (date) {
                    return 'black_text'
                }
                gantt.templates.scale_row_class = function (date) {
                    return 'black_text'
                }
                let lb = gantt.getLightboxType()

                if (listValue) {
                    let taskGoal = listValue.map(w => {
                        return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                    })
                    taskGoal = taskGoal.filter((value, index, self) => {
                        return self.indexOf(value) === index
                    })
                    gantt.templates.timeline_cell_class = function (task, date) {
                        // checks to see if the cell date is in the task goal list\
                        if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                            // get the index of the date (should be the same index to get the computed array above since both are using .map)
                            // this will compare the goal of the task vs the actual (how many people are working said hour)
                            let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                            let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                            if (goal == null || goal == Infinity) {
                                goal = 0
                            }
                            let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                            if (goal === actual) {
                                // if gaol = actual then its green (goal is met)
                                return 'at_goal'
                            } else if (goal - 1 == actual) {
                                // if its above, then its warning (yellow/over coverage)
                                return 'warning'
                            } else if (goal < actual) {
                                return 'over_goal'
                            } else {
                                // if its below goal the it is danger (red/low coverage)
                                return 'danger'
                            }
                        }
                    }
                }
                // gantt.attachEvent('onQuickInfo', function(taskId) {
                //     console.log('showing info', taskId)
                //     if (taskId == _t.quickInfoShowing) {
                //         gantt.hideQuickInfo()
                //         _t.quickInfoShowing = null
                //     } else {
                //         _t.quickInfoShowing = taskId
                //     }
                // })
                gantt.attachEvent("onTaskClick", function(id, e) {
                    if (_t.quickInfoShowing == false) {
                        setTimeout(function () {gantt.showQuickInfo(id)}, 250)
                        _t.quickInfoShowing = true
                        _t.quickInfoId = id
                    } else {
                        if (_t.quickInfoId === id) {
                            _t.quickInfoId = null
                            _t.quickInfoShowing = false
                            setTimeout(function () {gantt.hideQuickInfo()}, 250)
                        } else {
                            _t.quickInfoShowing = true
                            _t.quickInfoId = id
                            setTimeout(function() {gantt.showQuickInfo(id)}, 250)
                        }
                    }

                })
                gantt.$click.buttons.delete = function(id) {
                    gantt.deleteTask(id)
                }
                gantt.$click.buttons.edit = function(id) {
                    _t.$emit('droppedInfo', id)
                    return false
                }
                this.tasksShowing = this.$props.tasks.data
                gantt.init(this.gantt_ref)
                gantt.parse(this.$props.tasks)
            }
        },


        mounted() {
            let hourStepLookup = {
                    '1h': 1,
                    '4h': 4,
                    '1d': 24
                }
            let hourStep = hourStepLookup[this.hourlyType]
            if (hourStep)
                this.initialSetup()
        },
        watch: {
            tasks: function (value) {
                let allTasks = {data: [], links: []};
                let currCode = this.code == 'Other' ? 'Light Service' : this.code
                if (currCode == 'all') {
                    allTasks.data = value.data
                } else if(currCode == 'battery_light_service') {
                    allTasks.data = value.data.filter(p => {
                        if (['Battery', 'Light Service', 'battery_light_service'].includes(p.serviceType)) {return p}
                    })
                } else if(currCode == 'tow_light_service') {
                    allTasks.data = value.data.filter(p => {
                        if (['Tow', 'Light Service', 'tow_light_service'].includes(p.serviceType)) {return p}
                    })
                } else {
                    allTasks.data = value.data.filter(p => {
                        if (p.serviceType === currCode) return p
                    })
                }
                this.tasksShowing = allTasks.data
                // gantt.clearAll()
                gantt.parse(allTasks)
                gantt.render()
                // const tasks = value.data
                // const rows = gantt.$task_bg.childNodes
                // const rowClasses = []
                // for (let i = 0; i < tasks.length; i++) {
                //     const columns = rows[i].childNodes;
                //     const cols = [];
                //     for (let j = 0; j < columns.length; j++) {
                //         if (columns[j].classList.contains(tasks[i].text.replace(/\s/g, ''))) {
                //             cols.push(j);
                //         }
                //     }
                //     rowClasses.push(cols)
                // }
                // for (let i = 0; i < rows.length; i++) {
                //     const columns = rows[i].childNodes;
                //     for (let j = 0; j < columns.length; j++) {
                //         for (let k = 0; k < rowClasses.length; k++) {
                //             for (let l = 0; l < rowClasses[k].length; l++) {
                //                 if (k !== i && j === rowClasses[k][l]) {
                //                     rows[i].childNodes[j].classList.add(tasks[k].text.replace(/\s/g, ''))
                //                 }
                //             }
                //         }
                //     }
                // }
                // for (let i = 0; i < tasks.length; i++) {
                //     const elements = document.querySelectorAll(`.${tasks[i].text.replace(/\s/g, '')}`)
                //     for (let j = 0; j < elements.length; j++) {
                //         if (!elements[j].style.backgroundColor) {
                //             elements[j].style.backgroundColor = tasks[i].color
                //             elements[j].style.opacity = 0.5
                //         }
                //     }
                // }
            },
            code: function(value) {
                let allTasks = {data: [], links: []};
                let currCode = value == 'Other' ? 'Light Service' : value
                if (currCode == 'all') {
                    allTasks.data = this.tasks.data
                } else if(currCode == 'battery_light_service') {
                    allTasks.data = this.tasks.data.filter(p => {
                        if (['Battery', 'Light Service', 'battery_light_service'].includes(p.serviceType)) {return p}
                    })
                } else if(currCode == 'tow_light_service') {
                    allTasks.data = this.tasks.data.filter(p => {
                        if (['Tow', 'Light Service', 'tow_light_service'].includes(p.serviceType)) {return p}
                    })
                } else {
                    allTasks.data = this.tasks.data.filter(p => {
                        if (p.serviceType === currCode) return p
                    })
                }

                this.tasksShowing = allTasks.data
            },
            predictedHours: function (value, oldVal) {
                let listValue = value
                let taskGoal = listValue.map(w => {
                    return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                })
                taskGoal = taskGoal.filter((value, index, self) => {
                    return self.indexOf(value) === index
                })
                let _t = this
                let hourStepLookup = {
                    '1h': 1,
                    '4h': 4,
                    '1d': 24
                }
                let hourStep = hourStepLookup[this.hourlyType]

                            let dayFormat = "%D, %d, %F, %Y"

                if (this.hourlyType == '1d') {
                    dayFormat = "%m-%d"
                }

                gantt.config.scales = [
                    {
                        unit: "day", step: 1, format: dayFormat, css: function (date) {
                            return 'black_text'
                        }
                    },
                    {
                        unit: "hour", step: hourStep, format: function (date) {
                            let hour_format
                            if (hourStep == 1)
                                hour_format = moment(date).format('h:mmA')
                            if (hourStep == 4)
                                hour_format = moment(date).format('h:mmA') + '-' + moment(date).add(3, 'hours').format('h:59A')
                            if (hourStep == 24)
                                hour_format = moment(date).format('dddd')

                            return hour_format
                        }, css: function (date) {
                            if (listValue) {
                                let taskGoal = listValue.map(w => {
                                    return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                })
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index
                                })
                                // checks to see if the cell date is in the task goal list\
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                    // this will compare the goal of the task vs the actual (how many people are working said hour)
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity || goal == undefined) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (goal === actual) {
                                        // if gaol = actual then its green (goal is met)
                                        return 'at_goal_date'
                                    } else if (goal - 1 == actual) {
                                        // if its above, then its warning (yellow/over coverage)
                                        return 'warning_date'
                                    } else if (goal < actual) {
                                        return 'over_goal_date'
                                    } else {
                                        // if its below goal the it is danger (red/low coverage)
                                        return 'danger_date'
                                    }
                                }
                            }
                            return 'black_text'
                        },

                    }
                    // {unit: 'hour', steps: 1, format: function(date) { return moment(date).format('hA')}}

                ];
                if (!_t.noPredictions) {
                    gantt.config.scales.push({
                        unit: 'hour', step: hourStep, format: function(date) {
                            if(_t.predictedHours.length === 0 || _t.noPredictions) {
                                return ''
                            } else {
                                let taskGoal = listValue.map(w => {
                                    return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                })
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index;
                                })
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (!isNaN(actual) && !isNaN(goal))
                                        return actual + ' / ' + goal
                                    else
                                        return ''
                                } else {
                                    return ''
                                }
                            }
                        }, css: function (date) {
                                if (listValue) {
                                    let taskGoal = listValue.map(w => {
                                        return moment(w.sc_dt).format('MM/DD/YYYY HH:00')
                                    })
                                    taskGoal = taskGoal.filter((value, index, self) => {
                                        return self.indexOf(value) === index
                                    })
                                    // checks to see if the cell date is in the task goal list\
                                    if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                        // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                        // this will compare the goal of the task vs the actual (how many people are working said hour)
                                        let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                        let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                        if (goal == null || goal == Infinity) {
                                            goal = 0
                                        }
                                        let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                        if (goal === actual) {
                                            // if gaol = actual then its green (goal is met)
                                            return 'at_goal_date'
                                        } else if (goal - 1 == actual) {
                                            // if its above, then its warning (yellow/over coverage)
                                            return 'warning_date'
                                        } else if (goal < actual) {
                                            return 'over_goal_date'
                                        } else {
                                            // if its below goal the it is danger (red/low coverage)
                                            return 'danger_date'
                                        }
                                    }
                                }
                                return 'black_text'
                            }
                    })
                }
                if (['4h', '1d'].includes(this.hourlyType) && !this.noPredictions) {
                    let taskGoal = this.adjustedHours

                    gantt.config.scales.push({
                        unit: "hour", step: 1, format: function (date) {
                            return moment(date).format('h:mmA')
                        }, css: function (date) {
                            if (listValue) {
                                taskGoal = taskGoal.filter((value, index, self) => {
                                    return self.indexOf(value) === index
                                })
                                // checks to see if the cell date is in the task goal list\
                                if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                                    // get the index of the date (should be the same index to get the computed array above since both are using .map)
                                    // this will compare the goal of the task vs the actual (how many people are working said hour)
                                    let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                                    let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                                    if (goal == null || goal == Infinity || goal == undefined) {
                                        goal = 0
                                    }
                                    let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                                    if (goal === actual) {
                                        // if gaol = actual then its green (goal is met)
                                        return 'at_goal_date'
                                    } else if (goal - 1 == actual) {
                                        // if its above, then its warning (yellow/over coverage)
                                        return 'warning_date'
                                    } else if (goal < actual) {
                                        return 'over_goal_date'
                                    } else {
                                        // if its below goal the it is danger (red/low coverage)
                                        return 'danger_date'
                                    }
                                }
                            }
                            return 'black_text'
                        }
                    },)
                }
                if (this.hourlyType == '1d') {
                    gantt.config.scales.splice(1, 1)
                }
                gantt.templates.timeline_cell_class = function (task, date) {
                    // checks to see if the cell date is in the task goal list\
                    if (taskGoal.includes(moment(date).format('MM/DD/YYYY HH:00'))) {
                        // get the index of the date (should be the same index to get the computed array above since both are using .map)
                        // this will compare the goal of the task vs the actual (how many people are working said hour)
                        let iot = taskGoal.indexOf(moment(date).format('MM/DD/YYYY HH:00'))
                        let goal = _t.countTasks.length > 0 ? _t.countTasks[iot].goal : 0
                        if (goal == null || goal == Infinity) {
                            goal = 0
                        }
                        let actual = _t.countTasks.length > 0 ? _t.countTasks[iot].actual : 0
                        if (goal === actual) {
                            // if gaol = actual then its green (goal is met)
                            return 'at_goal'
                        } else if (goal - 1 == actual) {
                            // if its above, then its warning (yellow/over coverage)
                            return 'warning'
                        } else if (goal < actual) {
                            return 'over_goal'
                        } else {
                            // if its below goal the it is danger (red/low coverage)
                            return 'danger'
                        }
                    }
                }
                gantt.render()


            },
            date: function (val) {
                let newDate = new Date(val)

                gantt.clearAll()
                gantt.config.start_date = moment.utc(newDate).subtract(newDate.getHours(), 'hours')
                gantt.config.end_date = moment.utc(newDate).subtract(newDate.getHours(), 'hours').add(31, 'hours')

                gantt.render()
            },
            // editted: function () {
            //     gantt.render()
            // },
            refresh: function() {
                // gantt.clearAll()
                gantt.render()
            },
            clear: function(isclear) {
                if (isclear) {
                    for (let i = 0; i < this.tasks.data.length; i++){
                        gantt.deleteTask(this.tasks.data[i].id)
                    }
                    gantt.clearAll()
                    gantt.render()
                    this.$emit('cleared', true)
                }
            },
            taskToDelete: function(val) {
                if (val != null) {
                    gantt.deleteTask(val)
                }
            },
            hourlyType: function() {
                this.initialSetup()
            }
        }
    }
</script>

<style>
    @import "~dhtmlx-gantt/codebase/skins/dhtmlxgantt_material.css";

    .gantt_link_point,
    .gantt_task_progress_drag {
        display: none !important;
    }

    .danger {
        background: #F57773;
    }

    .at_goal {
        background: #1D8935;
    }

    .warning {
        background: #F5D273;
    }

    .over_goal {
        background: #7657A7;
    }

    .danger_date {
        background: #F57773;
        color: #fff !important;
    }

    .at_goal_date {
        background: #1D8935;
        color: #fff !important;
    }

    .warning_date {
        background: #F5D273;
        color: #000 !important;
    }

    .over_goal_date {
        background: #7657A7;
        color: #fff !important;
    }

    .tall-cell {
        height: 50px !important;
    }

    .black_text {
        color: #000 !important;
    }

    .quick-info {
        font-size: x-small;
        text-align: left;
        z-index: 900;
    }
    .gantt_cal_qi_tdate {
        display: none;
    }

    .gantt_cal_qi_content {
        font-size: 10px !important;
    }

    .gantt_cal_qi_title {
        display: none;
    }

    .gantt_cal_qi_controls div div {
        font-size: 10px !important;
        text-align: center;
    }

    .gantt_layout_cell {
        height: 550px;
    }

</style>
